"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24PeopleAddFill = function Svg24PeopleAddFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 12a4 4 0 1 0-.595-7.956A5.973 5.973 0 0 1 18 7.5a5.982 5.982 0 0 1-1.8 4.284c.408.14.845.216 1.3.216z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M19.5 18.5A1.5 1.5 0 0 1 18 20H6a1.5 1.5 0 0 1-1.5-1.5s0-.437.139-.989A5.27 5.27 0 0 1 5.55 15.6C6.641 14.145 8.634 13 12 13s5.359 1.145 6.45 2.6c.52.693.773 1.368.912 1.911.138.544.138.989.138.989zM23.5 17.5A1.5 1.5 0 0 1 22 19H20.96c.027-.163.041-.33.041-.5 0-2.201-1.36-4.315-3.166-5.495 2.42.073 3.939.942 4.804 2.095.505.673.862 1.547.862 2.4zM4.5 9.5a1 1 0 1 0-2 0V11H1a1 1 0 1 0 0 2h1.5v1.5a1 1 0 1 0 2 0V13H6a1 1 0 1 0 0-2H4.5V9.5z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24PeopleAddFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24PeopleAddFill;
exports.default = _default;